import { create } from 'zustand';

const useGuideStore = create(set => ({
    blockers: {},
    resetVersion: 0,
    setBlocker: (id, blocked) => set(state => {
        if (!!state.blockers[id] === blocked) return state;
        const blockers = { ...state.blockers };
        if (blocked) blockers[id] = true;
        else delete blockers[id];
        return { blockers };
    }),
    reset: () => set(state => ({ blockers: {}, resetVersion: state.resetVersion + 1 })),
}));

export default useGuideStore;
